// extracted by mini-css-extract-plugin
export default {"auto_order":"AutoOrder_auto_order__+nuFt"};